module.exports = __webpack_public_path__ + "img/home1.65b9df3e.png";